import { isTyping } from '@wellread/core';
import { useEffect } from 'react';
import { settingsOf } from '../lib/settings';
import { useLiveEvents } from '../lib/events';
import { useMe } from '../lib/queries';
import { applyChrome } from '../lib/theme';
import { useChrome } from '../state/chrome';

/** Keeps the page in the reader's theme and colour theme, as they change. */
export function useChromeTheme() {
  const me = useMe();
  const chrome = me.data ? settingsOf(me.data).chrome : undefined;
  useEffect(() => {
    if (chrome) applyChrome(chrome);
  }, [chrome]);
  return me;
}

/** Shared by every signed-in layout: theme and colour theme, live events, ⌘K. */
export function useBootstrap() {
  const me = useChromeTheme();
  const setPalette = useChrome((s) => s.setPalette);
  useLiveEvents(true);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPalette(true);
      } else if (e.key === '/' && !isTyping(e)) {
        e.preventDefault();
        setPalette(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setPalette]);
  return me;
}
